var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Stack } from "syf-component-library/ui/spacing";
import { Body, H3 } from "syf-component-library/ui/typography";
import { generateUUID } from "syf-js-utilities";
import { CancelButton, FooterWrapper } from "./subcomponents";
import { PAGE_NAME } from "../../../../../const/analytics";
import modalIds from "../../../../../const/modalIds";
import { useVantageContext } from "../../../../../context/vantageContext";
import triggerVantageAnalytics from "../../../../../helpers/triggerVantageAnalytics";
import VantageTrans from "../../../../atoms/VantageTrans";
import { Modal, ModalContent } from "../subcomponents";
var UnenrollSuccessModalPopUp = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    var navigateTo = useVantageContext().navigateTo;
    var t = useTranslation().t;
    var handleCloseButton = function () {
        onClose();
        navigateTo();
    };
    useEffect(function () {
        if (isOpen) {
            triggerVantageAnalytics({
                pageName: PAGE_NAME.VANTAGE_UNENROLLED,
            });
        }
    }, [isOpen]);
    return (_jsx(Modal, __assign({ id: "unenroll-success", title: "Unenroll Modal", containerId: modalIds.UNENROLL_SUCCESS_MODAL_ID, isOpen: isOpen, maxHeight: "450px", escapeModalHandler: handleCloseButton, "data-cy-include": true, footerButtons: [
            _jsx(FooterWrapper, { children: _jsx(CancelButton, __assign({ buttonType: "primary", onClick: handleCloseButton, type: "button", "data-type": "credit score unenrolled", "data-analytics": "clicktrackingevent", "data-reason": "close" }, { children: t("actions.close") })) }, generateUUID()),
        ] }, { children: _jsxs(ModalContent, { children: [_jsx(H3, __assign({ weight: "bold" }, { children: _jsx(VantageTrans, { i18nKey: "unenrollSuccessModal.title" }) })), _jsx(Stack, { size: "base" }), _jsx(Body, { children: _jsx(VantageTrans, { i18nKey: "unenrollSuccessModal.body" }) }), _jsx(Stack, { size: "base" })] }) })));
};
export default UnenrollSuccessModalPopUp;
